<template>
  <MazDialog v-model="isDialogOpened" persistent noClose title="Omadeus">
    <p>Would you prefer to use the Omadeus native app instead of a browser interface?</p>

    <template #footer>
      <MazBtn size="sm" class="maz-mr-2" outline @click="closeDialog">
        No
      </MazBtn>
      <MazBtn size="sm" @click="openAppOrRedirect">
        Yes
      </MazBtn>
    </template>
  </MazDialog>
</template>

<script>
import { MazBtn, MazDialog } from 'maz-ui'

export const USER_PLATFORM = {
  WEB: 'web',
  ANDROID: 'android',
  IOS: 'ios'
}

export default {
  name: 'OpenAppDialog',
  data () {
    return {
      appOpened: false,
      isDialogOpened: false
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog () {
      this.isDialogOpened = false
      this.$emit('input', false)
    },
    loadDownloadAppPopup () {
      let userPlatform = USER_PLATFORM.WEB

      if (/Mobi/.test(navigator.userAgent)) {
        if (/Android/.test(navigator.userAgent)) {
          userPlatform = USER_PLATFORM.ANDROID
        } else if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
          userPlatform = USER_PLATFORM.IOS
        } else {
          console.log('User is using a mobile device, but the specific platform is unknown.')
        }
      } else {
        userPlatform = USER_PLATFORM.WEB
      }

      if (userPlatform === USER_PLATFORM.WEB) return
      this.isDialogOpened = true
      this.$emit('input', true)
    },
    openAppOrRedirect () {
      const isAndroid = /Android/i.test(navigator.userAgent)
      const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)

      const appSchemeUrl = 'omadeus://'
      const appStoreUrl = isiOS
        ? 'https://apps.apple.com/us/app/omadeus/id1589598131'
        : isAndroid
          ? 'https://play.google.com/store/apps/details?id=de.netalic.stork'
          : null

      if (!appStoreUrl) return

      window.location.href = appSchemeUrl

      document.addEventListener('visibilitychange', this.handleVisibilityChange)

      setTimeout(() => {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)

        if (!this.appOpened) {
          window.location.href = appStoreUrl
        }
      }, 3500)
    },
    handleVisibilityChange () {
      if (document.visibilityState === 'hidden' && !this.appOpened) {
        this.appOpened = true
      }
    }
  },
  async mounted () {
    this.isDialogOpened = this.value
    this.loadDownloadAppPopup()
  },
  components: {
    MazDialog,
    MazBtn
  }
}
</script>
